import { ReactNode, useState } from 'react';
import Styles from "./Tooltip.module.scss";
import classnames from "classnames";

interface TooltipProps {
    text: string | ReactNode;
    children: string | ReactNode;
    posittion?: "top" | "left" | "bottom" | "right";
}

const Tooltip = ({ text, children, posittion = "bottom" }: TooltipProps) => {
    const [showTooltip, setShowTooltip] = useState(false);
    // const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    const handleMouseEnter = (event: any) => {
        setShowTooltip(true);
        const parentRect = event.target.getBoundingClientRect();
        setTooltipPosition({
            x: event.clientX  - parentRect.left,
            y: event.clientY - parentRect.top,
        });
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div
            style={{ position: 'relative', display: 'inline-block' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={Styles.container}
        >

            <div className={Styles.content}>

                {children}
                {showTooltip && (
                    <div
                        className={classnames(Styles.tooltip,Styles[posittion])}
                        style={{
                            top:tooltipPosition.y,
                            left:tooltipPosition.x
                        }}
                    >
                        {text}
                    </div>
                )}

            </div>
        </div>
    )
};

export default Tooltip;
